import moment from 'moment';
import { dateFormat } from '../../../../constants';
import { getStopApi, postStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';

export const lockOrUnlock = async ({url, authorization}) => {  
  return await postStopApi({
    url,
    'payload': '',
    authorization,
  }).then((response) => {
    return response;
  },
).catch((e) => alert(e))}

export const addHistory = async ({url, authorization}) => {  
  return await postStopApi({
    url,
    'payload': '',
    authorization,
  }).then((response) => {
    return response;
  },
).catch((e) => alert(e))}

export const deleteHistory = async ({url, authorization}) => {  
  return await deleteStopApi({
    url,
    'payload': '',
    authorization,
  }).then((response) => {
    return response;
  },
).catch((e) => alert(e))}

export const setFaxSentDate = async ({url, authorization}) => {
  return await postStopApi({
    url,
    'payload': '',
    authorization,
  }).then((response) => {
    return response;
  },
).catch((e) => alert(e))}   

export const getInvoiceHistoryList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return {
      isLoading: false,
      data: response.data,
      total: response.totalRows
    }
  }).catch((e) => alert(e));
};

export const getTransportationInvoiceList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    //console.log(response);
    return {
      isLoading: false,
      data: response.data,
      total: response.totalRows
    }
  }).catch((e) => alert(e));
};

export const getCountyList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return {
      isLoading: false,
      data: response.data,
      total: response.data.length
    }
  }).catch((e) => alert(e));
};

export const getCbpInvoiceList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        AllTmt: item.AllTmt,
        CBPProvider: item.CBPProvider,
        CbpID: item.CbpID,
        CbpInvID: item.CbpInvID,
        CreditTmt: item.CreditTmt,
        DCPAdj: item.DCPAdj,
        DateFaxed: item.DateFaxed
        ? moment(item.DateFaxed).format(dateFormat).split('T')[0]
        : '-',
        DateRecived: item.DateRecived
        ? moment(item.DateRecived).format(dateFormat).split('T')[0]
        : '-',
        DateFaxedWithOutFormate: item.DateFaxed,
        DateRecivedWithOutFormate: item.DateRecived,
        DateSentLocked: item.DateSentLocked,
        InMthTmt: item.InMthTmt,
        InvoiceAmt: item.InvoiceAmt,
        Month: item.Month,
        OutMthTmt: item.OutMthTmt,
        Signed: item.Signed,
      })),
    };
  }).catch((e) => alert(e));
};
